export const TimeFormats = {
  dateTimeWithOffset: "YYYY-MM-DD[T]HH:mm:ssZ",
  dateTimeUTC: "YYYYMMDD[T]HHmmss[Z]",
  allDay: "YYYYMMDD",
};
